"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localityTypeByIdPrefix = exports.default = exports.LocalityTypeName = exports.LocalityTypeKeys = void 0;
var _forOwn = _interopRequireDefault(require("lodash/forOwn"));
var _values = _interopRequireDefault(require("lodash/values"));
var _localityState = _interopRequireDefault(require("./locality-state"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var localityNamePattern = '[\\w-]+';
var statePattern = () => {
  var states = [];
  (0, _forOwn.default)(_localityState.default, value => {
    states.push(value.abbreviation);
  });
  return "(".concat(states.join('|').toLowerCase(), ")");
};
var postcodePattern = '\\d{1,4}';
var LocalityTypeName;
(function (LocalityTypeName) {
  LocalityTypeName["DIVISION"] = "DIVISION";
  LocalityTypeName["DISTRICT"] = "DISTRICT";
  LocalityTypeName["REGION"] = "REGION";
  LocalityTypeName["STREET"] = "STREET";
  LocalityTypeName["POSTCODE"] = "POSTCODE";
  LocalityTypeName["SCHOOL"] = "SCHOOL";
})(LocalityTypeName || (exports.LocalityTypeName = LocalityTypeName = {}));
var LocalityTypeKeys = exports.LocalityTypeKeys = Object.keys(LocalityTypeName);
var LocalityTypeValues = {
  DIVISION: {
    type: LocalityTypeName.DIVISION,
    name: LocalityTypeName.DIVISION,
    urlSlug: 'suburb',
    slugPattern: new RegExp("^(".concat(localityNamePattern, "-").concat(statePattern(), "-").concat(postcodePattern, ")$"), 'i'),
    shortSlugReplacement: '$1',
    idField: 'divisionId',
    idPrefix: 12
  },
  DISTRICT: {
    type: LocalityTypeName.DISTRICT,
    name: LocalityTypeName.DISTRICT,
    urlSlug: 'district',
    slugPattern: new RegExp("^(".concat(localityNamePattern, ")-district-(").concat(statePattern(), ")$"), 'i'),
    shortSlugReplacement: '$1-$2',
    idField: 'districtId',
    idPrefix: 11
  },
  REGION: {
    type: LocalityTypeName.REGION,
    name: LocalityTypeName.REGION,
    urlSlug: 'region',
    slugPattern: new RegExp("^(".concat(localityNamePattern, ")-region-(").concat(statePattern(), ")$"), 'i'),
    shortSlugReplacement: '$1-$2',
    idField: 'regionId',
    idPrefix: 10
  },
  STREET: {
    type: LocalityTypeName.STREET,
    name: LocalityTypeName.STREET,
    urlSlug: 'street'
  },
  POSTCODE: {
    type: LocalityTypeName.POSTCODE,
    name: LocalityTypeName.POSTCODE,
    urlSlug: 'postcode'
  },
  SCHOOL: {
    type: LocalityTypeName.SCHOOL,
    name: LocalityTypeName.SCHOOL,
    urlSlug: 'school'
  }
};
var LocalityType = LocalityTypeValues;
var localityTypeByIdPrefix = idPrefix => idPrefix ? (0, _values.default)(LocalityType).find(localityType => localityType.idPrefix === parseInt("".concat(idPrefix), 10)) : undefined;
exports.localityTypeByIdPrefix = localityTypeByIdPrefix;
var _default = exports.default = LocalityType;